import {
    NEW_PLUVIOMETRO_DIGITAL_SUCCESS,
    TABLE_PLUVIOMETRO_DIGITAL_PENDING,
    TABLE_PLUVIOMETRO_DIGITAL_SUCCESS,
    TABLE_PLUVIOMETRO_DIGITAL_FAILURE,
    LIST_PLUVIOMETRO_DIGITAL_PENDING,
    LIST_PLUVIOMETRO_DIGITAL_SUCCESS,
    LIST_PLUVIOMETRO_DIGITAL_FAILURE,
    FIND_PLUVIOMETRO_DIGITAL_PENDING,
    FIND_PLUVIOMETRO_DIGITAL_SUCCESS,
    FIND_PLUVIOMETRO_DIGITAL_FAILURE,
    DELETE_PLUVIOMETRO_DIGITAL_PENDING,
    DELETE_PLUVIOMETRO_DIGITAL_SUCCESS,
    DELETE_PLUVIOMETRO_DIGITAL_FAILURE,
    CREATE_PLUVIOMETRO_DIGITAL_PENDING,
    CREATE_PLUVIOMETRO_DIGITAL_SUCCESS,
    CREATE_PLUVIOMETRO_DIGITAL_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function pluviometroDigitalReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_PLUVIOMETRO_DIGITAL_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_PLUVIOMETRO_DIGITAL_PENDING:
        case FIND_PLUVIOMETRO_DIGITAL_PENDING:
        case DELETE_PLUVIOMETRO_DIGITAL_PENDING:
        case CREATE_PLUVIOMETRO_DIGITAL_PENDING:
        case TABLE_PLUVIOMETRO_DIGITAL_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_PLUVIOMETRO_DIGITAL_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_PLUVIOMETRO_DIGITAL_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_PLUVIOMETRO_DIGITAL_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_PLUVIOMETRO_DIGITAL_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_PLUVIOMETRO_DIGITAL_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_PLUVIOMETRO_DIGITAL_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_PLUVIOMETRO_DIGITAL_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_PLUVIOMETRO_DIGITAL_SUCCESS:
        case CREATE_PLUVIOMETRO_DIGITAL_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_PLUVIOMETRO_DIGITAL_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { pluviometroDigitalReducer };